<template>
  <div class="my-order my-like">
    <div class="title">我的收藏</div>
    <div class="collection_list">
      <div class="collection_box">
        <div class="collection_item" v-for="(item, index) in list" :key="index" :title="item['goods'].title">
          <a :href="'/GoodsDetail?id='+item['goods_id']" class="item_image">
            <img :src="$url.cdn(item['goods'].image)" alt=""/>
          </a>
          <div class="item_desc">
            <div class="item_desc_top">
              <a :href="'/GoodsDetail?id='+item['goods_id']" class="collection_title">{{ item["goods"].title }}</a>
            </div>
            <div class="collection_toast">支持七天内退换货（特殊定制探针除外）</div>
          </div>
          <div class="item_price">
            <div class="red">￥{{ formatPrice(item["goods"].price) }} 起</div>
            <div class="button" @click="deleteLike(item)">删除</div>
          </div>
        </div>
      </div>
      <el-pagination
        layout="prev, pager, next"
        @current-change="pageChange"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
  import userApi from '@/api/user'
  export default {
    data() {
      return {
        limit: 10,
        page : 1,
        total: 0,
        list : []
      };
    },
    created() {
      this.$emit("getCompontsIndex", 5);
      this.getList();
    },
    methods: {
      formatPrice(e) {
          return e.length === 1 ? e[0] : e.join('~');
      },
      async getList() {
        let {data} = await userApi.goodsLog.list({type: 'favorite', page: this.page, list_rows: this.limit})
        this.list = data.data;
        this.total = data.total;
      },  
      pageChange(e) {
        this.page = e;
        this.getList();
      },
      async deleteLike(item) {
        this.$confirm("删除该收藏?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText : "取消",
          type             : "warning"
        }).then(async () => {
          await userApi.favorite.cancel(item.goods_id)
          this.getList()
          this.$message({
            type   : "success",
            message: res.data.msg
          });
        });
      }
    }
  };
</script>
<style lang="less" scoped>
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/components/personal-info/my-like.vue